import React from 'react';

import Hero3 from '@/components/Hero3';
import VideoCarousel from '@/components/VideoCarousel';
import About from '../components/About';
import Erpcige from '../components/erpcige/erpcige';
import WhyUs from '../components/WhyUs';
import Services from '../components/Services/Services';
import Itsolutions from '@/components/itsolutions/itsolutions';
import Microsoftoffice from '@/components/microsoftoffice/microsoftoffice';
import Fedigitalcertificate from '@/components/fedigitalcertificate/fedigitalcertificate';
import SAPB1Reports from '../components/SAPB1Reports/SAPB1Reports';
import Contact from '../components/Contact';

export type Data = {
  img: string;
  title: string;
  description: string;
  location: string;
};

export type CurrentSlideData = {
  data: Data;
  index: number;
};

const Home: React.FC = () => {
  return (
    <div className="page-home">
      <Hero3 />
      <VideoCarousel />
      <About />
      <Erpcige /> 
      <WhyUs />
      <Services />
      <Itsolutions />
      <Microsoftoffice />
      <Fedigitalcertificate />
      <SAPB1Reports />
      <Contact />
     </div>
  );
};

export default Home;